import { UserPermissions } from '@centecomm/portal-service';
import { FeatureConfiguration } from 'Core/Types/FeatureConfiguration';
import InsuraceNavigationIcon from 'Icons/NavigationItem/Insurance';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements/LoadingContent';
import useComplianceHubEnabled from 'utils/Hooks/LaunchDarkly/useComplianceHubEnabled';

const LazyInsurancePage = React.lazy(() => import('./Pages/InsurancePage'));
const isComplianceHubEnabled = () => useComplianceHubEnabled();

const insuranceConfiguration: FeatureConfiguration = {
    name: 'Insurance',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureInsuranceTitle',
            url: '/insurance',
            Icon: InsuraceNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyInsurancePage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        permissions: [UserPermissions.ViewCertificateOfInsurance],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: (settings) => {
        if (isComplianceHubEnabled()) {
            return false;
        }

        if (settings && settings.insurance) {
            return settings.insurance.visible;
        }

        return false;
    },
};

export default insuranceConfiguration;
